import { render, staticRenderFns } from "./1037.vue?vue&type=template&id=608c3f60&scoped=true&"
import script from "./1037.vue?vue&type=script&lang=js&"
export * from "./1037.vue?vue&type=script&lang=js&"
import style0 from "./1037.vue?vue&type=style&index=0&id=608c3f60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608c3f60",
  null
  
)

export default component.exports